import axios from 'axios';

import {
  apiAdministrationApp,
  apiCertificationsAdminContracts,
  apiMasterCertifications,
  apiUrl,
  apiYClickMaster
} from '../resources/environmentConstants';

import { apiInterceptors } from './apiInterceptors';

// Services API
const apiInstance = axios.create({
  baseURL: apiUrl
});

apiInterceptors(apiInstance);

// Masters API
const apiYclickMasterInstance = axios.create({
  baseURL: apiYClickMaster
});

apiInterceptors(apiYclickMasterInstance);

// Certifications API - Contracts Admin
const apiAdminContractsInstance = axios.create({
  baseURL: apiCertificationsAdminContracts
});

apiInterceptors(apiAdminContractsInstance);

// Certifications Master API
const apiCertificationsMasterInstance = axios.create({
  baseURL: apiMasterCertifications
});

apiInterceptors(apiCertificationsMasterInstance);

// Administration Master API
const apiAdministrationMasterInstance = axios.create({
  baseURL: apiAdministrationApp
});

apiInterceptors(apiAdministrationMasterInstance);
export {
  apiInstance as api,
  apiYclickMasterInstance as apiYclickMaster,
  apiAdminContractsInstance as apiAdminContracts,
  apiCertificationsMasterInstance as apiCertificationsMaster,
  apiAdministrationMasterInstance as apiAdministrationMaster
};
